export class Hospice {
  name: string;
  streetAddress: string;
  state: string;
  city: string;
  zipcode: string;
  mailingAddress: string;
  phone: string;
  curantisId: number;
}

export class Patient {
  firstName: string;
  middle: string;
  lastName: string;
  id: string;
  name: string;
  curantisId?: string;
  patientChartCurantisId?: string;
  middleName: string;
}

export class CtiForm {
  hospice: Hospice;
  patient: Patient;
  narrativeStatement?: string;
  signature: string;
  date: Date;
}



// WEBPACK FOOTER //
// ./src/certification/models/hospice.ts